// plugins/preloadjs.client.ts

// Определяем типы для createjs, чтобы TypeScript не ругался.
// Это упрощенное определение. В идеале, нужны полные d.ts файлы для CreateJS.
interface CreateJSEvent {
	type: string
	target: any
	[key: string]: any // для других свойств события
}

interface CreateJSLoadItem {
	id?: string
	src: string
	type?: string
	[key: string]: any
}

interface LoadQueueInstance {
	new (preferXHR?: boolean, basePath?: string, crossOrigin?: string | boolean): this
	loadFile(file: CreateJSLoadItem | object | string, loadNow?: boolean, basePath?: string): void
	loadManifest(manifest: any[] | string | object, loadNow?: boolean, basePath?: string): void
	getResult(value: string, rawResult?: boolean): any
	getItem(value: string): CreateJSLoadItem | null
	on(
		type: string,
		listener: (event: CreateJSEvent) => void,
		scope?: any,
		once?: boolean,
		data?: any,
		useCapture?: boolean
	): Function
	off(type: string, listener: Function, useCapture?: boolean): void
	removeAllEventListeners(type?: string): void
	close(): void
	load(): void
	// Добавьте другие методы и свойства, которые вы используете
	[key: string]: any
}

interface PreloadJSNamespace {
	version: string
	buildDate: string
	LoadQueue: LoadQueueInstance // Это конструктор
	// Добавьте другие экспорты из createjs.PreloadJS, если они вам нужны
}

export interface CreateJSGlobal {
	PreloadJS: PreloadJSNamespace
	extend: Function
	promote: Function
	deprecate: Function
	proxy: Function
	indexOf: Function
	Event: any
	ErrorEvent: any
	EventDispatcher: any
	ProgressEvent: any
	Elements: any
	URLUtils: any
	DomUtils: any
	DataUtils: any
	Types: any
	Methods: any
	LoadItem: any
	RequestUtils: any
	AbstractLoader: any
	// ... другие модули CreateJS
}

// Расширяем глобальный интерфейс Window
declare global {
	interface Window {
		createjs?: CreateJSGlobal
	}
}

export default defineNuxtPlugin(async (nuxtApp) => {
	// Этот код выполнится только на клиенте
	// PreloadJS should load only when a page explicitly needs legacy preloader flow.
	const shouldLoadPreloadJs = document.documentElement.hasAttribute('data-use-preloadjs')
	if (!shouldLoadPreloadJs) {
		return
	}

	// Проверяем, загружен ли уже скрипт (на всякий случай)
	if (window.createjs && window.createjs.PreloadJS) {
		// Предоставляем createjs через nuxtApp, если он уже есть
		// Это позволяет использовать useNuxtApp().$createjs в компонентах
		nuxtApp.provide('createjs', window.createjs)
		return
	}

	// Динамически загружаем скрипт
	await new Promise<void>((resolve, reject) => {
		const script = document.createElement('script')
		script.src = '/js/preloadjs.min.js' // Путь к вашему файлу в public/
		script.async = true
		script.onload = () => {
			if (window.createjs && window.createjs.PreloadJS) {
				// Предоставляем createjs через nuxtApp
				nuxtApp.provide('createjs', window.createjs)
				resolve()
			} else {
				console.error('CreateJS или PreloadJS не найден на window после загрузки скрипта.')
				reject(new Error('Не удалось загрузить PreloadJS'))
			}
		}
		script.onerror = (error) => {
			console.error('Не удалось загрузить скрипт PreloadJS:', error)
			reject(error)
		}
		document.head.appendChild(script)
	})
})

